<app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
<div class="container">
  <div class="row">
    <div class="col-md-12 px-3">
      <h1><app-header-icon iconName="calculate"></app-header-icon> {{'FINANCIAL' | translate}}</h1 >
      <app-financial [type]="type" (typeChange)="updateBreadcrumbs($event)"></app-financial>
    </div>
  </div>
</div>
